import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/index/index'
import Apply from '@/views/apply/index'
import ApplySecondDetail from '@/views/apply/detail'
import ApplyDetail from '@/views/apply/applyDetail'
import Introduce from '@/views/about/introduce'
import xsydls from '@/views/fwzc/xsydls'
import onlineClass from '@/views/fwzc/onlineClass'
import tecArticles from '@/views/fwzc/tecArticles'
import news from '@/views/news/index'
import newsDetail from '@/views/news/detail'
import product from '@/views/center/index'
import productDetail from '@/views/center/productDetail'
import productVideo from '@/views/center/compontents/productVideo'
import joinUs from '@/views/about/joinUs'
import recruit from '@/views/recruit/index'
import about from '@/views/about/index'
import zlgl from '@/views/zlykkx/index'
import demo from '@/views/demo/index'
import { setLocale } from '../i18n'
import { updateGlobalSeo } from '@/utils/seo';
Vue.use(Router)

const router =  new Router({
  routes: [
    {
      path: '/',                  // 根路径，重定向到默认首页+语言
      redirect: '/home/zh'
    },
    {
      path: '/home/:lang?',       // 首页，语言后缀可选
      name: '首页',
      component: Home
    },
    {
      path: '/demo/:lang?',
      name: 'demo',
      component: demo
    },
    {
      path: '/apply/:lang?',
      name: '行业应用',
      component: Apply
    },
    {
      path: '/apply/detail/:lang?',
      name: '应用二级详情',
      component: ApplySecondDetail
    },
    {
      path: '/apply/applyDetail/:lang?',
      name: '应用详情',
      component: ApplyDetail
    },
    {
      path: '/introduce/:lang?',
      name: '联系我们',
      component: Introduce
    },
    {
      path: '/zlykkx/zlgl/:lang?',
      name: '质量管理',
      component: zlgl
    },
    {
      path: '/fwzc/xsydls/:lang?',
      name: '销售与代理商',
      component: xsydls
    },
    {
      path: '/fwzc/onlineClass/:lang?',
      name: '在线课堂',
      component: onlineClass
    },
    {
      path: '/fwzc/tecArticles/:lang?',
      name: '技术文章',
      component: tecArticles
    },
    {
      path: '/news/:lang?',
      name: '新闻资讯',
      component: news
    },
    {
      path: '/newsDetail/:lang?',
      name: '新闻资讯详情',
      component: newsDetail
    },
    {
      path: '/product/index/:lang?',
      name: '产品中心',
      component: product
    },
    {
      path: '/product/productDetail/:lang?',
      name: '产品详情',
      component: productDetail
    },
    {
      path: '/joinUs/:lang?',
      name: '加入我们',
      component: joinUs
    },
    {
      path: '/recruit/:lang?',
      name: '招聘',
      component: recruit
    },
    {
      path: '/about/:lang?',
      name: '关于',
      component: about
    },
    {
      path: '/productVideo/:lang?',
      name: '产品视频',
      component: productVideo
    },
    {
      path: '*',                 
      redirect: '/home/zh'
    }
  ],
  mode: 'history',
})
const supportedLangs = ['zh', 'en']
router.afterEach(() => {
  const state = Vue.prototype.$i18nState;
  if (state && state.locale) {
    updateGlobalSeo(state.locale);
  }
});
router.beforeEach((to, from, next) => {
  const lang = to.params.lang
  const currentPath = to.path
  // console.log('=== beforeEach ===')
  // console.log('to.path:', to.path)
  // console.log('to.params:', to.params)
  // console.log('to.params.lang:', to.params.lang)
  // 1. 如果已经有合法的语言参数，直接放行
  if (lang && supportedLangs.includes(lang)) {
    setLocale(lang)
    next()
    return
  }

  // 2. 如果语言参数不合法（存在但不是支持的语言）
  if (lang && !supportedLangs.includes(lang)) {
    // 去掉末尾的不合法语言段，然后加上默认语言
    const newPath = currentPath.replace(new RegExp(`/${lang}$`), '') + '/zh'
    // 防止自己重定向自己（理论上不会，但加上判断）
    if (newPath === currentPath) {
      next('/home/zh')
    } else {
      next(newPath)
    }
    return
  }

  // 3. 没有任何语言参数，则添加默认语言
  //    注意：需要判断当前路径是否已经以 /zh 或 /en 结尾（防止重复添加）
  const endsWithLang = /\/zh$|\/en$/.test(currentPath)
  if (!endsWithLang) {
    const newPath = currentPath + (currentPath.endsWith('/') ? 'zh' : '/zh')
    next(newPath)
  } else {
    // 路径末尾已有语言但 to.params.lang 却为空（罕见，比如手动输入 /home/zh 但路由定义问题）
    // 从路径中提取语言并设置
    const match = currentPath.match(/\/(zh|en)$/)
    if (match) {
      setLocale(match[1])
    }
    next()
  }
})
// 修复重复导航错误
const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated') {
      return err; // 忽略错误
    }
    throw err;
  });
};

// replace 也可能触发类似错误，一并修复
const originalReplace = router.replace;
router.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name === 'NavigationDuplicated') {
      return err;
    }
    throw err;
  });
};

export default router


// WEBPACK FOOTER //
// ./src/router/index.js